export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-tag/index.js